import React from 'react';
import { Link } from 'react-router-dom';
import { CATALOG, Song } from '../data/songs';
function SongLine({
  song
}: {
  song: Song;
}) {
  return <span className="lowercase" data-id="element-239">{`${song.title} (${song.duration})`}</span>;
}
export function Music() {
  return <main className="relative min-h-screen w-full bg-[#f5f5f5] px-6 py-6 text-black md:px-10 md:py-10" style={{
    fontFamily: 'Helvetica, "Helvetica Neue", Arial, "Arial Nova", sans-serif'
  }} data-id="element-240">
      {/* Header — matches the home page exactly */}
      <header className="flex w-full items-start justify-between text-sm leading-tight" data-id="element-241">
        <Link to="/" className="lowercase hover:opacity-60" data-id="element-242">
          lennon cripe
        </Link>

        <nav className="flex flex-col items-start text-left" data-id="element-243">
          <Link to="/music" className="lowercase hover:opacity-60" data-id="element-244">
            catalog
          </Link>
          <Link to="/tour" className="lowercase hover:opacity-60" data-id="element-245">
            tour
          </Link>
          <Link to="/shop" className="lowercase hover:opacity-60" data-id="element-246">
            shop
          </Link>
          <Link to="/guestbook" className="lowercase hover:opacity-60" data-id="element-247">
            guestbook
          </Link>
        </nav>

        <a href="mailto:info@weedwaster.com" className="lowercase hover:opacity-60" data-id="element-248">
          contact
        </a>
      </header>

      {/* Catalog: years -> releases -> songs */}
      <section className="mt-20 flex w-full flex-col items-start text-sm md:mt-24" data-id="element-249">
        {CATALOG.map((group, yearIdx) => <div key={group.year} className={`flex w-full flex-col items-start ${yearIdx > 0 ? 'mt-8' : ''}`} data-id="element-250">
            {/* Year label */}
            <p className="mb-2 font-bold lowercase" data-id="element-251">{group.year}</p>

            {/* Releases within this year */}
            {group.releases.map((release, releaseIdx) => <div key={`${group.year}-${releaseIdx}`} className={`flex flex-col items-start gap-1 ${releaseIdx > 0 ? 'mt-4' : ''}`} data-id="element-252">
                {/* Release name (only if it's a named EP / B side) */}
                {release.name && <p className="font-bold lowercase" data-id="element-253">{release.name}</p>}

                {/* Tracks */}
                {release.songs.map(song => <SongLine key={song.id} song={song} data-id="element-254" />)}
              </div>)}
          </div>)}
      </section>

      {/* Footer Padding */}
      <div className="h-24" data-id="element-255" />
    </main>;
}